import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import ResultBarChart from "./BarChart";
// import ReactWordcloud from "react-wordcloud";
import { updateTabStates } from "../../../store/actions";
import { getSurveyResultsFromAPI } from "../../../services/surveyResultService";
import Button from "../../layout/button";
import { theme } from "antd";
import { Auth } from "aws-amplify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
export default function Results() {
  const dispatch = useDispatch();

  const themeMode = useSelector((state) => state.themeMode);
  // const currentSurveyResult = useSelector(state => state.currentSurveyResult);
  // const resultsCurrentQuestions = useSelector(state => state.resultsCurrentQuestions);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  const currentSurvey = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.currentSurvey;
  const currentSurveyResult = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.currentSurveyResult;
  const resultsCurrentQuestions = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.resultsCurrentQuestions;
  const currentSurveyInsightData = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.currentSurveyInsightData;
  const [questions, setQuestions] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [infoText, setInfoText] = useState("");
  const [allSections, setAllSections] = useState([]);
  const [allPages, setAllPages] = useState([]);
  const [isOpenSectionMenu, setIsOpenSectionMenu] = useState(false);
  const [isOpenPageMenu, setIsOpenPageMenu] = useState(false);
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedPage, setSelectedPage] = useState("");
  const userSelectRef = useRef(null);
  const [token, setToken] = useState("");

  async function checkAuth() {
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      await cognitoUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          const { idToken, refreshToken, accessToken } = session;
          getToken(idToken.jwtToken);
        }
      );
    } catch (e) { }
  }

  async function getToken(token) {
    if (token) {
      setToken(token);
    } else {
      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    }
  }

  useEffect(() => {
    if (token.length > 0) {
      getResults();
    }
  }, [token]);

function exportAnswersToExcel(items) {
    const rows = [];

    items.forEach(sectionItem => {
        const sectionName = sectionItem.section;
        const questions = sectionItem.data;
        questions.forEach(q => {
          if (q.type === "comment" || q.type === "tagbox" || q.type === "checkbox" || q.type === "ranking" || q.type === "boolean" || q.type === "text") return;
            q.answers.forEach((a, index) => {
                rows.push({
                    Section: index === 0 ? sectionName : "",
                    Page: index === 0 ? (q.page || "") : "",
                    Question: index === 0 ? (q.question || "") : "",
                    Answer: a.answer || "",
                    Percentage: a.percentage || 0
                });
            });
        });
    });

    const worksheet = XLSX.utils.json_to_sheet(rows);

    // Header rengi (fill) ve font bold denemesi
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell_address = XLSX.utils.encode_cell({ r: 0, c: C });
        if (!worksheet[cell_address]) continue;

        worksheet[cell_address].s = {
            font: { bold: true }, // free sürümde çoğu Excel bunu görmez
            fill: {
                fgColor: { rgb: "FFD9D9D9" } // açık gri
            }
        };
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Survey Answers");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Survey_Answers.xlsx");
}


  useEffect(() => {
    let _newQuestions = [];
    currentSurveyResult?.forEach((res) => {
      res["data"].forEach((data) => {
        if (data.type !== "text") {
          _newQuestions.push({
            section: res["section"],
            page: data["page"],
            type: data["type"],
            question: data["question"],
            question_id: data["question_id"],
            rate: data["answers"],
            explanationHeader: "", //findFirstSentenceAndRest(data["comment"])["firstSentence"],
            explanationBody: "", //findFirstSentenceAndRest(data["comment"])["remainingText"]
          });
        }
      });
    });
    setQuestions(_newQuestions);
    setFilteredQuestions(_newQuestions);
  }, [currentSurveyResult]);

  const [currentIndex, setCurrentIndex] = useState(
    filteredQuestions?.findIndex(
      (q) => q.resultsCurrentQuestions?.type === resultsCurrentQuestions?.name
    ) || 0
  );
  const [currentQuestion, setCurrentQuestion] = useState({});

  // useEffect(() => {
  //     if (filteredQuestions.length > 0) {
  //         setCurrentQuestion(filteredQuestions[currentIndex]);
  //         console.log('setCurrentQuestion...............', filteredQuestions[currentIndex]);
  //         setChartData(
  //             Object.entries(filteredQuestions[currentIndex].rate).map(
  //                 ([key, value]) => ({
  //                     label: value["answer"],
  //                     value: value["percentage"],
  //                 })
  //         ));
  //     }
  //     else {
  //         console.log('No questions available'); // Length 0 olduğunda aksiyon
  //         // Burada length 0 olduğunda yapılacak işlemi belirtebilirsiniz
  //         // Örneğin:
  //         setCurrentQuestion("");
  //         setChartData([]);
  //         setInfoText("Currently, there are no questions available")
  //     }
  // }, [filteredQuestions]);

  useEffect(() => {
    if (resultsCurrentQuestions) {
      if (resultsCurrentQuestions.type === "section") {
        const ind = filteredQuestions.findIndex(
          (q) => q.section === resultsCurrentQuestions.name
        );
        setCurrentIndex(ind);
      } else if (resultsCurrentQuestions.type === "page") {
        const ind = filteredQuestions.findIndex(
          (q) => q.page === resultsCurrentQuestions.name
        );
        setCurrentIndex(ind);
      } else if (resultsCurrentQuestions.type === "question") {
        const ind = filteredQuestions.findIndex(
          (q) => q.question_id === resultsCurrentQuestions.question_id
        );
        setCurrentIndex(ind);
      }
    }
  }, [resultsCurrentQuestions, filteredQuestions]);

  useEffect(() => {
    if (filteredQuestions.length > 0) {
      setCurrentQuestion(filteredQuestions[currentIndex]);
      if (filteredQuestions[currentIndex]) {
        const question = filteredQuestions[currentIndex];
        const type = question.type;

        // Bu tipler chart'a dahil edilmesin
        const skipTypes = ["comment", "tagbox", "checkbox", "ranking", "boolean", "text"];

        if (skipTypes.includes(type)) {
          setChartData([]);   // Chart boşaltılıyor
          return;             // Chart data oluşturulmasın
        }

        // Chart'a uygun tip → normal mapping
        setChartData(
          Object.entries(question?.rate || {}).map(([key, value]) => ({
            label: value["answer"],
            value: value["percentage"],
          }))
        );
      }

    }
  }, [currentIndex, filteredQuestions]);

  useEffect(() => {
    if (filteredQuestions.length > 0) {
      const sectionsData = [
        ...new Set(filteredQuestions.map((item) => item.section)),
      ];
      setAllSections(sectionsData);
      const pagesData = [
        ...new Set(filteredQuestions.map((item) => item.page)),
      ];
      setAllPages(pagesData);
      setInfoText(""); // Eğer `filteredQuestions` dolarsa infoText'i sıfırla
    }
  }, [filteredQuestions]);

  useEffect(() => {
    if (currentQuestion == undefined && filteredQuestions.length > 0) {
      setCurrentIndex(0);
      setCurrentQuestion(filteredQuestions[0]);
    }
  }, [currentQuestion]);

  const nextQuestion = () => {
    if (currentIndex < filteredQuestions.length - 1) {
        dispatch(
          updateTabStates(topMenuTabs.activeTab, "resultsCurrentQuestions", {
            question_id: filteredQuestions[currentIndex + 1].question_id,
            name: filteredQuestions[currentIndex + 1].question,
            type: "question",
          })
        );

      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevQuestion = () => {
    if (currentIndex > 0) {
        dispatch(
          updateTabStates(topMenuTabs.activeTab, "resultsCurrentQuestions", {
            question_id: filteredQuestions[currentIndex + 1].question_id,
            name: filteredQuestions[currentIndex + 1].question,
            type: "question",
          })
        );

      setCurrentIndex(currentIndex - 1);
    }
  };

  const [chartData, setChartData] = useState(null);
  const handleClickOutside = (event, ref, setState) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setState(false); // Eğer dışarıya tıklanırsa, ilgili modalı kapat
    }
  };
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  useEffect(() => {
    if (isOpenMenu) {
      document.addEventListener("click", (event) =>
        handleClickOutside(event, userSelectRef, setIsOpenMenu)
      );
    }

    return () => {
      document.removeEventListener("click", (event) =>
        handleClickOutside(event, userSelectRef, setIsOpenMenu)
      );
    };
  }, [isOpenMenu]);
  // useEffect(() => {
  //     if (surveySection) {
  //         navigateToSection(surveySection);
  //     }
  // }, [surveySection]);

  // useEffect(() => {
  //     if (surveyPageName) {
  //         navigateToPage(surveyPageName);
  //     }
  // }, [surveyPageName]);

  // useEffect(() => {
  //     if (surveyQuestionId) {
  //         navigateToQuestion(surveyQuestionId);
  //     }
  // }, [surveyQuestionId]);
  const [tempQuestions, setTempQuestions] = useState([
    {
      section: "Section1",
      pages: [{ name: "Page1", questions: [{}] }],
    },
  ]);

  const cloudRef = useRef(null);

  const wordCloudOptions = {
    rotations: 2,
    rotationAngles: [-90, 0],
    fontSizes: [20, 60], // Minimum ve maksimum font boyutu
  };

  const callbacks = {
    // getWordColor: word => word.value > 50 ? "blue" : "red",
    // onWordClick: (word, event) => console.log("Word clicked:", word.text),
    // onWordMouseOver: (word, event) => console.log("Mouse over:", word.text),
    // onWordMouseOut: (word, event) => console.log("Mouse out:", word.text),
    getWordTooltip: (word) => `${word.text} (${word.value})`,
  };


async function getResults() {
  // 1) currentSurvey veya ID yoksa çağrı yapma
  
  if ( currentSurvey.ID =="" || currentSurvey.status !== "Draft" ) {
     
    dispatch(updateTabStates(topMenuTabs.activeTab, "pageIsLoading", false));
    return;
  }

  try {
    const result = await getSurveyResultsFromAPI(token, currentSurvey.ID);

    // 2) API result içinde results yoksa hata fırlatma
    if (!result || !result.results) {
    
      
      dispatch(
        updateTabStates(
          topMenuTabs.activeTab,
          "currentSurveyResult",
          null // veya [] kullanabilirsin
        )
      );

      dispatch(updateTabStates(topMenuTabs.activeTab, "pageIsLoading", false));
      return;
    }

    // 3) Normal akış
    dispatch(
      updateTabStates(
        topMenuTabs.activeTab,
        "currentSurveyResult",
        result.results
      )
    );

    dispatch(updateTabStates(topMenuTabs.activeTab, "pageIsLoading", false));

  } catch (error) {
    if (error?.message === "Request failed with status code 401") {
      checkAuth();
    } else {
      dispatch(updateTabStates(topMenuTabs.activeTab, "pageIsLoading", false));
    }
  }
}

  return infoText.length === 0 ? (
    <div
      className={`flex flex-col items-center justify-start w-full p-4 px-14 ${themeMode === "dark"
          ? "bg-[#1a1a28] text-white"
          : "bg-[#fbfbfc] text-black"
        }`}
    >
      {currentQuestion?.type !== undefined && (
        <div
          className=" flex flex-row w-full justify-between items-center"

        >
          <div className="flex gap-4 mb-8 justify-end text-end w-3/4 " id="resultsButtons" >
            <Button text="Previous" onClick={prevQuestion} id="surveyResultsPrev" disabled={currentIndex === 0} themeMode={themeMode} />
            <Button text="Next" onClick={nextQuestion}   id="surveyResultsNext" disabled={currentIndex === filteredQuestions.length - 1} themeMode={themeMode} />
            <Button text="Excel" onClick={() => exportAnswersToExcel(currentSurveyResult)}   id="surveyResultsExcel"  themeMode={themeMode} />


            <div className="cursor-pointer" onClick={getResults}  id="surveyResultsRefresh">
              <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="20px" height="20px" viewBox="0 0 512 512"
                preserveAspectRatio="xMidYMid meet">

                <g transform="translate(0,512) scale(0.1,-0.1)" fill={`${themeMode==="dark"?"#ffffff":"#000000"}`} stroke="none">
                  <path d="M2390 4794 c-441 -40 -832 -189 -1180 -448 -123 -91 -346 -315 -436
                      -436 -229 -308 -373 -652 -431 -1030 -24 -158 -24 -482 0 -640 50 -325 167
                      -635 341 -900 98 -149 164 -230 300 -366 344 -343 765 -554 1256 -630 159 -25
                      481 -25 640 0 825 127 1497 673 1784 1450 55 148 49 224 -23 289 -46 41 -68
                      49 -229 82 -128 26 -162 25 -222 -6 -60 -30 -97 -79 -139 -183 -145 -354 -401
                      -644 -726 -822 -726 -395 -1636 -169 -2097 520 -367 549 -355 1274 30 1816 86
                      121 251 286 372 372 169 120 400 223 592 262 439 90 826 4 1190 -266 l80 -60
                      -181 -182 c-116 -118 -187 -197 -197 -222 -53 -124 21 -267 151 -294 34 -7
                      256 -10 661 -8 l609 3 45 25 c24 14 58 45 75 68 l30 44 3 646 2 646 -26 53
                      c-33 69 -103 113 -180 113 -87 0 -130 -30 -343 -244 l-194 -194 -76 60 c-308
                      246 -651 403 -1011 463 -92 16 -379 27 -470 19z"/>
                </g>
              </svg>
            </div>
          </div>
        </div>
      )}
      <div className="w-full text-start" id="resultsQuestionData">
        <h1
          className={`text-[16px] font-bold mb-4 ${themeMode === "dark"
              ? "text-[#D9D9D9]"
              : "text-black text-opacity-60"
            }`}
        >
          {currentQuestion?.section ? currentQuestion?.section + " > " : ""}
          {currentQuestion?.page}
        </h1>
        <p
          className={`text-[24px] mb-6 text-left  ${themeMode === "dark"
              ? "text-[#F5F2F2]"
              : "text-black text-opacity-60"
            }`}
        >
          {currentQuestion?.question}
        </p>
        <div className="text-left w-3/4">
          {chartData &&
            currentQuestion?.type !== "comment" &&
            currentQuestion?.type !== "text" &&
            currentQuestion?.type !== "rating" && (
              <ResultBarChart data={chartData} xKey="label" yKey="value" />
            )}
          {currentQuestion?.type === "comment" && (
            // <div>
            //   <ReactWordcloud
            //     words={filteredQuestions[currentIndex]?.rate}
            //     options={wordCloudOptions}
            //     callbacks={callbacks}
            //     ref={cloudRef}
            //   size={[600,400]}
            //   />
            // </div>
            <div></div>
          )}
          {currentQuestion?.type === "rating" && (
            <ResultBarChart
              data={
                chartData?.map((x) => {
                  if (x && x.label) {
                    // Eğer 'x' ve 'label' mevcutsa, işlemi yap
                    x["label"] = x["label"] + " Star";
                  }
                  return x; // Sonuç olarak her 'x' objesini döndür
                }) || []
              }
              xKey="label"
              yKey="value"
            />
          )}
        </div>
      </div>
      {currentQuestion?.type !== undefined &&
        (currentSurvey?.content?.pages.find(p => p.type === "demographics")?.name !== currentQuestion?.section) &&
        (currentSurveyInsightData?.report_detail?.question_comments?.find((x) => x.question == currentQuestion?.question)?.comment !== undefined) && (
          <div className="w-full text-start  mt-4 pb-4 flex flex-col justify-start">
            <div
              className={`shadow-md rounded-lg pt-2 px-0 pb-4  min-w-[150px] w-3/4 h-auto border-l border-l-[4px] border-l-[#596877] rounded-l-none
                      ${themeMode === "dark"
                  ? "bg-[#000000] hover:bg-[#282834] text-white cursor-pointer "
                  : "bg-white text-gray-800 cursor-pointer"
                }
                        
                      `}
            >
              <div className="p-4 py-1 rounded-lg space-y-8">
                <div className="flex justify-between items-center mb-3">
                  <span
                    className={`size-5 whitespace-nowrap text-sm sm:text-[20px] font-bold ${themeMode === "dark" ? "text-[#FFFFFF]" : "text-gray-800"
                      }`}
                  >
                    Review
                  </span>
                </div>
                <div className="flex justify-start flex-col space-y-2 mb-3 border py-4 divide-y">
                  <div className="flex justify-start space-x-16 items-center px-2">
                    <div className="flex justify-start space-x-2 items-center">
                      <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex flex-shrink-0 text-center justify-center items-center text-xl text-black font-bold">
                        {" "}
                        1
                      </span>
                      <p
                        className={`text-md  font-bold ${themeMode === "dark"
                            ? "text-[#FFFFFF]"
                            : "text-gray-800"
                          }`}
                      >
                        {
                          currentSurveyInsightData?.report_detail?.question_comments
                            ?.find((x) => x.question == currentQuestion?.question)
                            ?.comment?.split(/(?<!\d)\./)[0]
                        }
                        .
                      </p>
                    </div>
                  </div>
                  <div className="flex  space-x-16 items-center pt-2 px-2">
                    <div className="flex justify-start space-x-2 items-center">
                      <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                        {" "}
                        2
                      </span>
                      <p
                        className={`text-md  font-bold ${themeMode === "dark"
                            ? "text-[#FFFFFF]"
                            : "text-gray-800"
                          }`}
                      >
                        {
                          currentSurveyInsightData?.report_detail?.question_comments
                            ?.find((x) => x.question == currentQuestion?.question)
                            ?.comment?.split(/(?<!\d)\./)[1]
                        }
                        .
                      </p>
                    </div>
                  </div>
                  <div className="flex justify-start space-x-16 items-center pt-2 px-2">
                    <div className="flex justify-start space-x-2 items-center">
                      <span className="rounded-full w-8 h-8 bg-[#8AAFEA] flex text-center justify-center items-center text-xl text-black font-bold">
                        {" "}
                        3
                      </span>
                      <p
                        className={`text-md  font-bold ${themeMode === "dark"
                            ? "text-[#FFFFFF]"
                            : "text-gray-800"
                          }`}
                      >
                        {
                          currentSurveyInsightData?.report_detail?.question_comments
                            ?.find((x) => x.question == currentQuestion?.question)
                            ?.comment?.split(/(?<!\d)\./)[2]
                        }
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
    </div>
  ) : (
    <div
      className={`flex flex-col items-center justify-center w-full h-full p-4 ${themeMode === "dark"
          ? "bg-[#1a1a28] text-white"
          : "bg-[#fbfbfc] text-black"
        }`}
    >
      <div
        className={`${themeMode === "dark"
            ? "text-white text-opacity-60"
            : "text-black text-opacity-60"
          } text-sm`}
      >
        {infoText}
      </div>{" "}
    </div>
  );
}
